// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import X from "@insite/mobius/Icons/X";
import cartLineSharedStyles from "@rpsc/App/SharedStyles/CartLineSharedStyles";
import { discontinuedProductListLineStyles } from "@rpsc/Overrides/Widgets/MyListsDetails/MyListDetailsDiscontinuedProductListLine";
import { mergeWithCss, sharedProductDescriptionStyles, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

discontinuedProductListLineStyles.restrictedDescriptionText = {
    ...sharedProductDescriptionStyles().productDetailDescription,
};

discontinuedProductListLineStyles.productPartNumbersStyles = {
    ...mergeWithCss(cartLineSharedStyles.productPartNumbers, {
        container: {
            css: css`
                margin-bottom: 0;
            `,
        },
    }),
};

discontinuedProductListLineStyles.chipTypographyStyles = {
    css: css`
        margin: 12px 0;
    `,
};

discontinuedProductListLineStyles.deleteLink = {
    mergeCss: true,
    icon: {
        iconProps: {
            src: X,
            size: 12,
            css: css`
                margin-right: 6px;
            `,
        },
    },
    typographyProps: {
        size: 12,
        lineHeight: "14px,",
    },
    css: css`
        display: flex;
        justify-content: center;
        margin-left: auto;
        margin-top: 4px;
        ${xScreen("lte", "md")} {
            margin-top: 12px;
        }
        &:focus {
            outline: none;
        }
    `,
};
